import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ExpressivePowerForNro = lazy(() =>
  import("@scenes/ExpressivePower/scenes/ExpressivePowerForNro").then((module) => ({
    default: module.ExpressivePowerForNro,
  }))
);

export const queryBuilderNRO: NavigationRoutingObject = {
  Component: ExpressivePowerForNro,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("query-builder-sidebar-pill-menu-option", "Query Builder"),
  pageNameForTracking: () => "Query Builder",
  featureLimitationKeys: ["can_only_view_landing_page_query_builder"],
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userCanViewReports = hasPermission("appGroup", {
      permission: "viewReporting",
    });

    return isImpersonating || userCanViewReports;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("query-builder-alt-keyword-1", "SQL queries"),
        t("query-builder-alt-keyword-2", "query template"),
        t("query-builder-alt-keyword-3", "custom query"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
